export const API_BASE_URL = 'https://api-data.compra-agora.com';

export const PUBLIC_API_URL = 'https://api-data.compra-agora.com';
